/*
 * Dashboard Views
 */

define([
  "marionette",
  "jquery",
  "modules/dashboard/template/dashboardTemplate.html",
  "messaging/messenger",
], function (Marionette, $, DashboardTemplate, Messenger) {
  var DashboardView = {};

  DashboardView.dashboardLayout = Marionette.Layout.extend({
    template: DashboardTemplate,
    events: {
      //need to use events here instead of triggers because we need the events to propogate
      "click #shortUsageTab": function () {
        this.trigger("show:short:usage");
      },
      "click #longUsageTab": function () {
        this.trigger("show:long:usage");
      },
      "click #escalationsTab": function () {
        this.trigger("show:escalations");
      },
      "change #dashboardTouchpointSelect": function () {
        //parseInt makes sure that the returned value is a number, not a string
        var optionSelected = this.$el.find("#dashboardTouchpointSelect option:selected").val();
        var optionSelectedNumber = parseInt(optionSelected, 10);
        this.trigger("change:touchpoint", optionSelectedNumber);
      },
      "change #dashboardLocaleSelect": function () {
        //parseInt makes sure that the returned value is a number, not a string
        var optionSelected = this.$el.find("#dashboardLocaleSelect option:selected").val();
        var optionSelectedNumber = parseInt(optionSelected, 10);
        this.trigger("change:locale", optionSelectedNumber);
      },
    },
    getAllTouchpoints: function () {
      //Grabs all touchpoints that are available on the UI and returns them separated by underscores
      var options = this.$el.find("#dashboardTouchpointSelect option");
      var touchpoints = "";
      for (var i = 1; i < options.length; i++) {
        //intentionally starting with 1, not 0.  First one is dummy "All"
        touchpoints = touchpoints + options[i].value;
        if (i < options.length - 1) touchpoints = touchpoints + "_";
      }
      return touchpoints;
    },
    onRender: function () {
      this.$el.i18n();
      //make sure that the highcharts resize properly when we click on their tab
      this.$el.find('a[data-toggle="tab"]').on("shown", function (e) {
        $(window).trigger("resize");
      });
    },
    regions: {
      accuracyPane: "#accuracyPane",
      shortUsagePane: "#shortUsagePane",
      longUsagePane: "#longUsagePane",
      escalationsPane: "#escalationsPane",
      topTopicList: "#topTopicList",
      learner: "#dashboardLearner",
      contents: "#dashboardContents",
    },
    triggers: {
      "click #topicsButton": "click:topics:button",
      "click #learnerButton": "click:learner:button",
      "click #contentsButton": "click:contents:button",
      "click #showQuickCreate": "show:quick:create",
    },
  });

  return DashboardView;
});
